import React, { useState, useCallback, useReducer, useMemo } from 'react';
import produce from 'immer';

function reducer(state, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case 'UPDATE':
        return action.value;
      case 'RESET':
        return action.initialData;
      default:
        return state;
    }
  });
}

function useTextArea(initialData) {
  const [state, dispatch] = useReducer(reducer, initialData);

  const update = useCallback(
    (value) => {
      if (state === value) {
        return;
      }

      dispatch({
        type: 'UPDATE',
        value,
      });
    },
    [state],
  );

  const handleChange = useCallback(
    (e) => {
      // console.log('handle change...', e.target.value);
      update(e.target.value);
    },
    [update],
  );

  const reset = useCallback(() => {
    dispatch({
      type: 'RESET',
      initialData,
    });
  }, [initialData]);

  return {
    state,
    handleChange,
    update,
    reset,
  };
}

export default useTextArea;
